import { G } from '@mobily/ts-belt';
import { friendlyFormatIBAN, ValidationErrorsIBAN, validateIBAN } from 'ibantools';
import { TextInput, TextInputProps, Validator } from 'react-admin';
import { match } from 'ts-pattern';

export const isValidIban = (value: string | undefined) => {
  if (G.isNullable(value)) {
    return;
  }
  const validationResult = validateIBAN(value.replaceAll(' ', '').toLocaleUpperCase());

  if (!validationResult.valid) {
    return match(validationResult.errorCodes.at(0))
      .with(
        ValidationErrorsIBAN.ChecksumNotNumber,
        () => 'resources.bo_common.validation.iban.checksum_not_number',
      )
      .with(
        ValidationErrorsIBAN.NoIBANCountry,
        () => 'resources.bo_common.validation.iban.no_iban_country',
      )
      .with(
        ValidationErrorsIBAN.NoIBANProvided,
        () => 'resources.bo_common.validation.iban.no_iban_provided',
      )
      .with(
        ValidationErrorsIBAN.QRIBANNotAllowed,
        () => 'resources.bo_common.validation.iban.qriban_not_allowed',
      )
      .with(
        ValidationErrorsIBAN.WrongBBANFormat,
        () => 'resources.bo_common.validation.iban.wrong_bban_format',
      )
      .with(
        ValidationErrorsIBAN.WrongBBANLength,
        () => 'resources.bo_common.validation.iban.wrong_bban_length',
      )
      .with(
        ValidationErrorsIBAN.WrongIBANChecksum,
        () => 'resources.bo_common.validation.iban.wrong_iban_checksum',
      )
      .otherwise(() => 'resources.bo_common.validation.iban.format');
  }
};

type IbanInputProps = TextInputProps & { testId?: string };

export const IbanInput = ({ validate, testId, ...props }: IbanInputProps) => {
  const validators: Validator[] = [isValidIban];

  if (validate) {
    validators.push(...(Array.isArray(validate) ? validate : [validate]));
  }

  const placeholder = 'FRXX XXXX XXXX XXXX XXXX XXXX XXX';

  const formatIban = (value: string) => friendlyFormatIBAN(value);

  return (
    <TextInput
      placeholder={placeholder}
      {...props}
      data-testid={testId}
      validate={validators}
      parse={formatIban}
    />
  );
};
